import { useTranslation } from 'react-i18next'

import ConditionsEditor from '@/common/components/ConditionsEditor/ConditionsEditor'

import { errorTypes } from '../constants'
import { getConditionTypes } from './helpers'

const VisibilityCriterionConditionsEditor = ({
  conditions,
  onChange,
  productTypes,
  productCategories,
  productCollections,
  returnReasons,
  regions,
  errors,
  currencies,
  storeCurrencyCode,
  disabled,
  disabledConditionFields,
}) => {
  const { t, i18n } = useTranslation()

  const conditionTypes = getConditionTypes({
    productTypes,
    productCategories,
    productCollections,
    returnReasons,
    regions,
    language: i18n.language,
    disabledConditionFields,
    t,
  })

  return (
    <ConditionsEditor
      conditions={conditions}
      onChange={onChange}
      errors={errors}
      title="Condiciones"
      description="Define el conjunto de condiciones que definen el criterio de visibilidad"
      emptyMessage="Se requiere al menos una condición para que el criterio tenga efecto."
      conditionTypes={conditionTypes}
      errorType={errorTypes.conditionIncomplete}
      currencies={currencies}
      storeCurrencyCode={storeCurrencyCode}
      disabled={disabled}
    />
  )
}

export default VisibilityCriterionConditionsEditor
